module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.358.9/frontend/_next/static/images/header_cover-2a6da6219a61812f3a22149f26383de0.jpg";